
const DiscountType = {
    CONSUMER: "CONSUMER",
    CATEGORY: "CATEGORY",
    PRODUCT: "PRODUCT"
};

export default DiscountType;